import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

const Login = () => {
  const { t } = useTranslation();

  const handleLinkClick = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };
  return (
    <div>
      <main className="page-content">
        <div className="tm-section-two1 tm-section-menphoto wishlist-section-ones">
          <div className="container">
            <div className="row">
              <div className="col-lg-4 center-box">
                <div className="login-logo">
                  <h4>
                    <a href="index.html">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        viewBox="0 0 512 512"
                      >
                        <path d="M41.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.3 256 246.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160zm352-160l-160 160c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L301.3 256 438.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0z" />
                      </svg>
                    </a>
                  </h4>
                  <a href="index.html"></a>
                  <a href="index.html" className="tm-header-logo">
                    <img src="assets/images/logo.png" alt="Jewelry-Demo" />
                  </a>
                </div>
                <form
                  action="#"
                  className="tm-form tm-login-form login-text center-box1"
                >
                  <h4>{t("L1")}</h4>
                  <p> {t("L2")}</p>
                  <div className="tm-form-inner">
                    <div className="tm-form-field tm-form-field1 neme-text">
                      <label htmlFor="login-email">
                      {t("L3")}
                      </label>
                      <input
                        type="email"
                        id="login-password"
                        required="required"
                      />
                    </div>
                    <div className="tm-form-field neme-text">
                      <label htmlFor="login-password">{t("L4")}</label>
                      <input
                        type="password"
                        id="login-password"
                        required="required"
                      />
                    </div>
                    <div className="tm-form-field tm-form-font">
                      <input
                        type="checkbox"
                        name="login-remember"
                        id="login-remember"
                      />
                      <label htmlFor="login-remember">{t("L5")}</label>
                      <p className="mb-0">
                        <a href="#">{t("L6")}</a>
                      </p>
                    </div>
                    <div className="tm-form-field">
                      <button type="submit" className="tm-button tm-button-one">
                      {t("L1")}
                      </button>
                    </div>
                    {/* <div class="tm-form-field">
										<div class="tm-form-sociallogin">
											<h6>Or, Login with :</h6>
											<ul>
												<li><a href="#" class="facebook-btn"><i class="ion-social-facebook"></i></a></li>
												<li><a href="#" class="google-btn"><i class="ion-social-google"></i></a></li>
											</ul>
										</div>
									</div> */}
                  </div>
                </form>
                <div className="login-footer">
                  {/* <div className="login-first">
                    <h6>New to Jewellery</h6>
                  </div> */}
                  <div className="create-account-text">
                   <Link to ="/Register">
                      
                      
                      {t("L7")}</Link>
                  </div>
                  <div className="create-account-text1">
                    {/* <ul>
                      <li>
                        <Link to="/Termcond" onClick={handleLinkClick}>
                        {t("L8")}
                        </Link>
                      </li>
                      <li>
                   
                        <Link to="/privacy-policy"  onClick={handleLinkClick}>{t("L9")}</Link>
                      </li>
                      <li>
                        <Link to="/Refunds"  onClick={handleLinkClick}> {t("L10")} </Link>
                      </li>
                    </ul> */}
                    {/* <p className="tm-footer-copyright1">
                    {t("L11")}
                      <a href="https://satellitekeyit.com /">
                        Satellitekeyit sol. pvt. ltd.
                      </a>
                    </p> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Login;
